import { uiChatReducerState } from "./uiChatTypes";
import { uiChatReducerActionTypes } from "./uiChatTypes";

// conversationReducer.ts

const initialState: uiChatReducerState = {
    userUtterance: null,
    intent: {
        customer_request: 'test',
        category: 'test',
        intent: 'test',
        intent_type: 'test',
        system_message: 'supported'
    },
    uiComponent: {
        "type": '',
        "props": {}
    },

    // uiComponent: {
    //     "type": "RestaurantMenuItems",
    //     "props": {
    //         "menu_items": [
    //             {
    //                 "category": "Breakfast",
    //                 "item_name": "Masala Tea",
    //                 "is_flexi_unit": false,
    //                 "unit": "NOS",
    //                 "rate": 39
    //             },
    //             {
    //                 "category": "Breakfast",
    //                 "item_name": "Lemon Tea",
    //                 "is_flexi_unit": false,
    //                 "unit": "NOS",
    //                 "rate": 39
    //             },
    //             {
    //                 "category": "Breakfast",
    //                 "item_name": "Green Tea",
    //                 "is_flexi_unit": false,
    //                 "unit": "NOS",
    //                 "rate": 39
    //             }
    //         ],
    //         "bar_drinks": [
    //             {
    //                 "item_name": "100 PIPER 12YEAR",
    //                 "unit": "ML",
    //                 "category": "PREMIUM SCOTCH"
    //             },
    //             {
    //                 "item_name": "100 PIPER 8YEAR",
    //                 "unit": "ML",
    //                 "category": "REGULAR SCOTCH"
    //             },
    //             {
    //                 "item_name": "ABSOLUT VODKA",
    //                 "unit": "ML",
    //                 "category": "DELUXE VODKA"
    //             }
    //         ]
    //     }
    // },


    agentLogId: null,
    guests: [],
    missingFields: [],
    approvalSuccess: false,
    loading: false,
    error: null,
    errorIdentityUpload: null,
    loadingIdentityDetails: false,
    update_message: '',
    update_success: false,
    history: [], // Timeline of user/system messages 
    detected_language: null,
    audio_status: "clear",
    previous_screen_load_timestamp: null,
    previous_agent_log_id: null,
    systemResponseRequestStartTime: null,
    lastSystemResponseTimeSeconds: null,
};

const uiChatReducer = (state = initialState, action: any): uiChatReducerState => {
    switch (action.type) {
        case uiChatReducerActionTypes.API_RESPONSE_SUCCESS:
            if (!action.payload?.actionType) {
                console.error(
                    `API_RESPONSE_SUCCESS: Missing actionType in payload. Action type: ${action.type}, Payload:`, action.payload
                );
                throw new Error(
                    `Reducer error: Missing actionType in payload for API_RESPONSE_SUCCESS. Action: ${JSON.stringify(action)}`
                );
            }

            switch (action.payload.actionType) {



                case uiChatReducerActionTypes.GET_SYSTEM_RESPONSE: {
                    console.log("[uiChatReducer.ts] GET_SYSTEM_RESPONSE success case triggered", action.payload);

                    const whatsapp_login_component = { type: "WhatsappLogin", props: {} };

                    // Always defensive: payload and sub-fields may be missing.
                    const data = action.payload?.data ?? {};
                    const intent =
                        data.intent ?? {
                            customer_request: "",
                            category: "",
                            intent: "",
                            intent_type: "",
                            system_message: "supported",
                        };

                    // If uiComponent is null/missing, keep previous; if auth required, override.
                    const nextUiComponent =
                        intent?.system_message === "auth_required"
                            ? whatsapp_login_component
                            : data.uiComponent ?? state.uiComponent ?? { type: "", props: {} };

                    const now = Date.now();
                    let responseTimeSeconds: number | null = null;

                    if (state.systemResponseRequestStartTime) {
                        responseTimeSeconds = (now - state.systemResponseRequestStartTime) / 1000;
                    }

                    return {
                        ...state,
                        userUtterance: intent?.customer_request ?? state.userUtterance ?? null,
                        intent, // will be the default stub if API sent null
                        uiComponent: nextUiComponent,
                        agentLogId: data.agent_log_id ?? null,
                        missingFields: data.missingFields ?? [],
                        loading: false,
                        audio_status: data.audio_status ?? state.audio_status,
                        error: null, // clear any prior error on success
                        previous_screen_load_timestamp: Date.now(), //store epoch ms (number; easiest to compare/sort)
                        previous_agent_log_id: data.agent_log_id ?? null,
                        // ✅ store the computed duration
                        lastSystemResponseTimeSeconds: responseTimeSeconds,
                        systemResponseRequestStartTime: null, // clear
                    };
                }

                case uiChatReducerActionTypes.SEND_APPROVED_ENTRY:
                    console.log("[uiChatReducer.ts] SEND_APPROVED_ENTRY success case triggred", action.payload);

                    return {
                        ...state,
                        approvalSuccess: action.payload.data.isSuccess,
                        loading: false,
                        // intent: action.payload.data.intent,
                        uiComponent: action.payload.data.approved_booking.updated_entry_json,
                        guests: action.payload.data.approved_booking.check_in_guest_data,
                        // agentLogId: action.payload.data.agent_log_id,
                        // missingFields: action.payload.data.missingFields
                        // isRoomListLoading: true,
                        // errorMessage: "",
                    };

                case uiChatReducerActionTypes.SEND_MANUALLY_UPDATED_ENTRY:
                    console.log("[uiChatReducer.ts] SEND_MANUALLY_UPDATED_NEW_BOOKING_ENTRY success case triggred", action.payload);

                    return {
                        ...state,
                        uiComponent: action.payload.data.uiComponent,
                        agentLogId: action.payload.data.agent_log_id,
                        missingFields: action.payload.data.missingFields,
                        update_message: '',
                        ...(action.payload.data.guests ? { guests: action.payload.data.guests } : {}),
                        // approvalSuccess: action.payload.data.isSuccess,
                        // guests: [],
                        loading: false,

                        update_success: action.payload.data.update_success
                        // intent: action.payload.data.intent,
                        // uiComponent: action.payload.data.uiComponent,
                        // agentLogId: action.payload.data.agent_log_id,
                        // missingFields: action.payload.data.missingFields
                        // isRoomListLoading: true,
                        // errorMessage: "",
                    };


                case uiChatReducerActionTypes.SEND_IDENTITY_DOCUMENT:
                    console.log("[uiChatReducer.ts] SEND_IDENTITY_DOCUMENT success case triggred", action.payload);

                    return {
                        ...state,
                        // approvalSuccess: action.payload.data.isSuccess,
                        loadingIdentityDetails: false,
                        guests: [
                            ...(state.guests || []),
                            ...(action.payload.data.guest || [])
                        ]
                        // intent: action.payload.data.intent,
                        // uiComponent: action.payload.data.uiComponent,
                        // agentLogId: action.payload.data.agent_log_id,
                        // missingFields: action.payload.data.missingFields
                        // isRoomListLoading: true,
                        // errorMessage: "",
                    };


                case uiChatReducerActionTypes.DELETE_IDENTITY_DOCUMENT:
                    console.log(
                        "[uiChatReducer.ts] DELETE_IDENTITY_DOCUMENT success case triggered",
                        action.payload
                    );

                    const { data } = action.payload || {};
                    if (!data || !data.guest) {
                        console.error("❌ No guest info in DELETE_IDENTITY_DOCUMENT payload:", action.payload);
                        return {
                            ...state,
                            loading: false,  // make sure we stop spinner even on bad payload
                        };
                    }

                    const guestToDelete = data.guest;

                    // remove by image_path (unique enough)
                    const updatedGuests = state.guests.filter(
                        (g) => g.image_path !== guestToDelete.image_path
                    );

                    return {
                        ...state,
                        loading: false,              // ✅ stop global loading
                        loadingIdentityDetails: false, // ✅ stop identity details loading if used
                        guests: updatedGuests,
                        error: null,
                    };


                // NEW: load initial state from file (success)
                case uiChatReducerActionTypes.LOAD_INITIAL_STATE_FROM_FILE: {
                    console.log("[uiChatReducer.ts] LOAD_INITIAL_STATE_FROM_FILE success case triggered", action.payload);

                    // Only pick/merge known keys to avoid poisoning the store
                    const data = action.payload.data || {};
                    const next: uiChatReducerState = {
                        ...state,
                        userUtterance: data.userUtterance ?? state.userUtterance,
                        intent: data.intent ?? state.intent,
                        uiComponent: data.uiComponent ?? state.uiComponent,
                        agentLogId: data.agentLogId ?? state.agentLogId,
                        guests: Array.isArray(data.guests) ? data.guests : state.guests,
                        missingFields: Array.isArray(data.missingFields) ? data.missingFields : state.missingFields,
                        approvalSuccess: typeof data.approvalSuccess === "boolean" ? data.approvalSuccess : state.approvalSuccess,
                        loading: false,
                        error: null,
                        history: Array.isArray(data.history) ? data.history : state.history,
                    };
                    return next;
                }



                // Cases to be inserted later
                default:
                    return {
                        ...state,
                    };
            }

        case uiChatReducerActionTypes.API_RESPONSE_ERROR:
            if (!action.payload?.actionType) {
                console.error(
                    `API_RESPONSE_ERROR: Missing actionType in payload. Action type: ${action.type}, Payload:`, action.payload
                );
                throw new Error(
                    `Reducer error: Missing actionType in payload for API_RESPONSE_ERROR. Action: ${JSON.stringify(action)}`
                );
            }

            switch (action.payload.actionType) {

                case uiChatReducerActionTypes.GET_SYSTEM_RESPONSE:
                    console.log("[uiChatReducer.ts] GET_SYSTEM_RESPONSE errror case triggred", action.payload);

                    const nowError = Date.now();
                    let responseTimeSecondsError: number | null = null;
                    if (state.systemResponseRequestStartTime) {
                        responseTimeSecondsError = (nowError - state.systemResponseRequestStartTime) / 1000;
                    }

                    return {
                        ...state,
                        intent: null,
                        uiComponent: null,
                        agentLogId: null,
                        missingFields: null,
                        approvalSuccess: false,
                        loading: false,
                        error: "Apologies! Something went wrong",
                        lastSystemResponseTimeSeconds: responseTimeSecondsError,
                        systemResponseRequestStartTime: null,
                        // isRoomListLoading: true,
                        // errorMessage: "",
                    };

                case uiChatReducerActionTypes.SEND_APPROVED_ENTRY:
                    console.log("[uiChatReducer.ts] SEND_APPROVED_ENTRY errror case triggred", action.payload);

                    return {
                        ...state,
                        uiComponent: action.payload.error.approved_booking.old_entry_json,
                        missingFields: action.payload.error.approved_booking.missingFields,
                        approvalSuccess: false,
                        loading: false,
                        error: "Apologies! Something went wrong"
                        // intent: null,
                        // uiComponent: null,
                        // agentLogId: null,
                        // missingFields: null
                        // isRoomListLoading: true,
                        // errorMessage: "",
                    };


                case uiChatReducerActionTypes.SEND_MANUALLY_UPDATED_ENTRY:
                    console.log("[uiChatReducer.ts] SEND_MANUALLY_UPDATED_ENTRY errror case triggred", action.payload);

                    return {
                        ...state,
                        // approvalSuccess: false,
                        loading: false,
                        update_message: action.payload.error,
                        update_success: false,
                        error: "Apologies! Something went wrong"
                        // intent: null,
                        // uiComponent: null,
                        // agentLogId: null,
                        // missingFields: null
                        // isRoomListLoading: true,
                        // errorMessage: "",
                    };


                case uiChatReducerActionTypes.SEND_IDENTITY_DOCUMENT:
                    console.log("[uiChatReducer.ts] SEND_IDENTITY_DOCUMENT errror case triggred", action.payload);

                    return {
                        ...state,
                        guests: [],
                        // approvalSuccess: false,
                        loadingIdentityDetails: false,
                        errorIdentityUpload: action.payload.error
                        // intent: null,
                        // uiComponent: null,
                        // agentLogId: null,
                        // missingFields: null
                        // isRoomListLoading: true,
                        // errorMessage: "",
                    };


                case uiChatReducerActionTypes.DELETE_IDENTITY_DOCUMENT:
                    console.log("[uiChatReducer.ts] DELETE_IDENTITY_DOCUMENT error case triggered", action.payload);

                    return {
                        ...state,
                        loadingIdentityDetails: false,
                        update_message: action.payload.error,
                        update_success: false,
                        errorIdentityUpload: action.payload.error || "Apologies! Something went wrong",
                    };

                // NEW: load initial state from file (error)
                case uiChatReducerActionTypes.LOAD_INITIAL_STATE_FROM_FILE:
                    console.log("[uiChatReducer.ts] LOAD_INITIAL_STATE_FROM_FILE error case triggered", action.payload);
                    return {
                        ...state,
                        loading: false,
                        error: "Apologies! Something went wrong loading state file"
                    };

                // NEW: save to file (error) - typically shouldn't fail, but keep parity
                case uiChatReducerActionTypes.SAVE_STATE_TO_FILE:
                    console.log("[uiChatReducer.ts] SAVE_STATE_TO_FILE error case triggered", action.payload);
                    return {
                        ...state,
                        loading: false,
                        error: "Apologies! Something went wrong saving state file"
                    };


                // Cases to be inserted later
                default:
                    return {
                        ...state,
                    };
            }
        case uiChatReducerActionTypes.GET_SYSTEM_RESPONSE:
            console.log("[uiChatReducer.ts] GET_SYSTEM_RESPONSE pre api case triggred", action.payload);

            return {
                ...state,
                userUtterance: action.payload.transcript,
                guests: [],
                approvalSuccess: false,
                audio_status: 'clear',
                loading: true,
                error: null,
                previous_screen_load_timestamp: null,
                previous_agent_log_id: null,
                // ✅ start timer here
                systemResponseRequestStartTime: Date.now(),
                lastSystemResponseTimeSeconds: null, // reset old value
                // isRoomListLoading: true,
                // errorMessage: "",
                //  clear previous_screen_load_timestamp time previous_agent_log id
            };

        case uiChatReducerActionTypes.SEND_APPROVED_ENTRY:
            console.log("[uiChatReducer.ts] SEND_APPROVED_ENTRY pre api case triggred", action.payload);

            return {
                ...state,
                approvalSuccess: false,
                loading: true,
                error: null
                // userUtterance: action.payload.transcript
                // isRoomListLoading: true,
                // errorMessage: "",
            };

        case uiChatReducerActionTypes.SEND_MANUALLY_UPDATED_ENTRY:
            console.log("[uiChatReducer.ts] SEND_MANUALLY_UPDATED_ENTRY pre api case triggred", action.payload);

            return {
                ...state,
                // approvalSuccess: false,
                update_success: false,
                update_message: '',
                loading: true,
                error: null
                // userUtterance: action.payload.transcript
                // isRoomListLoading: true,
                // errorMessage: "",
            };


        case uiChatReducerActionTypes.SEND_IDENTITY_DOCUMENT:
            console.log("[uiChatReducer.ts] SEND_IDENTITY_DOCUMENT pre api case triggred", action.payload);

            return {
                ...state,
                // approvalSuccess: false,
                loadingIdentityDetails: true,
                errorIdentityUpload: null
                // userUtterance: action.payload.transcript
                // isRoomListLoading: true,
                // errorMessage: "",
            };

        case uiChatReducerActionTypes.RESET_IDENTITY_DOCUMENT:
            console.log("[uiChatReducer.ts] RESET_IDENTITY_DOCUMENT pre api case triggred", action.payload);

            return {
                ...state,
                guests: null,
                // approvalSuccess: false,
                loading: true,
                error: null
                // userUtterance: action.payload.transcript
                // isRoomListLoading: true,
                // errorMessage: "",
            };

        case uiChatReducerActionTypes.DELETE_IDENTITY_DOCUMENT:
            console.log("[uiChatReducer.ts] DELETE_IDENTITY_DOCUMENT pre API case triggered", action.payload);

            // Keep existing guests; do not clear the array
            return {
                ...state,
                loadingIdentityDetails: true, // show loading specifically for identity documents
                errorIdentityUpload: null,
            };

        // NEW: pre case for loading from file (sets loading)
        case uiChatReducerActionTypes.LOAD_INITIAL_STATE_FROM_FILE:
            console.log("[uiChatReducer.ts] LOAD_INITIAL_STATE_FROM_FILE pre api case triggered", action.payload);
            return {
                ...state,
                loading: true,
                error: null
            };

        // NEW: pre case for saving to file (sets loading)
        case uiChatReducerActionTypes.SAVE_STATE_TO_FILE:
            console.log("[uiChatReducer.ts] SAVE_STATE_TO_FILE pre api case triggered", action.payload);
            return {
                ...state,
                loading: true,
                error: null
            };


        // NEW: pre case for to change langugae (sets loading)
        case uiChatReducerActionTypes.DETECTED_LANGUAGE:
            console.log("[uiChatReducer.ts] DETECTED_LANGUAGE pre api case triggered", action.payload);
            return {
                ...state,
                detected_language: action.payload,
                loading: true,
                error: null
            };

        case uiChatReducerActionTypes.SET_UICOMPONENT:
            console.log("[uiChatReducer.ts] SET_UICOMPONENT pre api case triggered", action.payload);
            return {
                ...state,
                uiComponent: action.payload,

                // loading: true,
                error: null
            };

        default:
            return state;
    }
};


export default uiChatReducer;
